import dayjs from 'dayjs';

// In-market dates are only allowed on a Sunday, no more than MAX_WEEKS_AHEAD weeks from today.
export const MAX_WEEKS_AHEAD = 52;

export const toYyyyMmDdInput = (apiDate) => {
    if (!apiDate) return '';
    const s = String(apiDate);
    const m = s.match(/^(\d{4}-\d{2}-\d{2})/);
    return m ? m[1] : s.slice(0, 10);
};

export const isSunday = (yyyyMmDd) => !!yyyyMmDd && dayjs(yyyyMmDd).day() === 0;

// Latest selectable date: MAX_WEEKS_AHEAD weeks from today (YYYY-MM-DD sorts chronologically).
export const maxInMarketDate = () => dayjs().add(MAX_WEEKS_AHEAD, 'week').format('YYYY-MM-DD');

// Allowed only if it is a Sunday on or before the 52-week limit.
export const isAllowedInMarketDate = (yyyyMmDd) => isSunday(yyyyMmDd) && yyyyMmDd <= maxInMarketDate();
